module.exports = __webpack_public_path__ + "img/40_38_088_940.a3b42dd2.jpg";